var _defs, _path, _path2, _path3, _circle, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew270({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.64,7.76A1.92,1.92,0,0,1,8,6.53a1.11,1.11,0,0,1,.89-.44,1.09,1.09,0,0,1,.62.2,1.33,1.33,0,0,1,.44.56,2.08,2.08,0,0,1,.17.87,1.9,1.9,0,0,1-.32,1.14A1.09,1.09,0,0,1,8,8.85,1.78,1.78,0,0,1,7.64,7.76Zm.35,0a1.4,1.4,0,0,0,.26.9A.75.75,0,0,0,8.87,9a.79.79,0,0,0,.63-.32,1.55,1.55,0,0,0,.25-1A1.81,1.81,0,0,0,9.62,7a.83.83,0,0,0-.3-.39.71.71,0,0,0-.44-.15.79.79,0,0,0-.64.32A1.62,1.62,0,0,0,8,7.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.54,9.29V6.15h1.14a1.17,1.17,0,0,1,.53.09.61.61,0,0,1,.28.29A1,1,0,0,1,12.6,7a.89.89,0,0,1-.18.58.88.88,0,0,1-.54.28,1,1,0,0,1,.21.18,1.56,1.56,0,0,1,.27.4l.45.85h-.43L12,8.64a3.47,3.47,0,0,0-.3-.52.79.79,0,0,0-.2-.18.64.64,0,0,0-.27,0h-.39V9.29Zm.34-1.75h.73A.89.89,0,0,0,12,7.48a.49.49,0,0,0,.2-.18A.69.69,0,0,0,12.25,7a.52.52,0,0,0-.14-.38.56.56,0,0,0-.41-.13h-.82Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.36,8.06V7.69h1.09V8.86a2.17,2.17,0,0,1-.52.37,1.33,1.33,0,0,1-.55.12,1.2,1.2,0,0,1-.68-.19,1.42,1.42,0,0,1-.47-.55,2.08,2.08,0,0,1-.17-.87,2.06,2.06,0,0,1,.18-.9,1.17,1.17,0,0,1,.45-.56,1.15,1.15,0,0,1,.67-.19,1.1,1.1,0,0,1,.49.11.92.92,0,0,1,.35.3,1.46,1.46,0,0,1,.21.53l-.31.1a1,1,0,0,0-.16-.4.65.65,0,0,0-.25-.21.74.74,0,0,0-.34-.07.88.88,0,0,0-.49.14.94.94,0,0,0-.32.42,1.82,1.82,0,0,0-.13.7,1.44,1.44,0,0,0,.27,1,.83.83,0,0,0,.68.31,1.05,1.05,0,0,0,.75-.32V8.06Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 3.37,
    cy: 8.03,
    r: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.37,
    y1: 8.03,
    x2: 6.37,
    y2: 8.03
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.62,
    y1: 9.05,
    x2: 6.12,
    y2: 9.05
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.62,
    y1: 7,
    x2: 6.12,
    y2: 7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 1.12,
    y1: 10.08,
    x2: 5.62,
    y2: 10.08
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 1.12,
    y1: 5.98,
    x2: 5.62,
    y2: 5.98
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew270);
export default __webpack_public_path__ + "static/media/Symbolpack_New_270.c1d9c1dc5da1b5cc1615374257b96c0b.svg";
export { ForwardRef as ReactComponent };